import React, { useEffect } from 'react';

import ReactSlider from 'react-slick'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import './Slider.css'

const HomeSlider = () => { 
    useEffect(() => {
        
        if (window.$('.main-slider-carousel').length) {
            window.$('.main-slider-carousel').owlCarousel({
                loop: true,
                margin: 0,
                nav: true,
                animateOut: 'slideOutDown',
                animateIn: 'fadeIn',
                active: true,
                smartSpeed: 1000,
                autoplay: 5000,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 1
                    },
                    1200: {
                        items: 1
                    }
                }
            });
        }
        
        
        return () => {
            if (window.$('.main-slider-carousel').data('owl.carousel')) {
                window.$('.main-slider-carousel').owlCarousel('destroy');
            }
        };
    }, []);

  return (
    <div>
       <section class="elementor-section elementor-top-section elementor-element elementor-element-844f0e0 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="844f0e0" data-element_type="section">
                <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ab7c0f7" data-id="ab7c0f7" data-element_type="column">
                        <div class="elementor-widget-wrap elementor-element-populated">
                            <div class="elementor-element elementor-element-1bec070 elementor-widget elementor-widget-wpsection_bannar_three" data-id="1bec070" data-element_type="widget" data-widget_type="wpsection_bannar_three.default">
                                <div class="elementor-widget-container">
                                    <section class="main-slider2 ">
                                        <div class="container-fluid">
                                            <ul class="main-slider-carousel owl-carousel owl-theme slide-nav">

                                                <li class="slider-wrapper">
                                                    <div class="image ">
                                                        <img src="./images/gallery1.jpeg" alt="" />
                                                    </div>
                                                    <div class="slider-caption text-center">
                                                        <div class="container">
                                                        <h1 style={{fontFamily:"Ubuntu"}}>Elevate Your Biking Experience With Our Cutting-Edge Air Filters</h1>
                                                        </div>
                                                    </div>
                                                    <div class="slide-overlay"></div>
                                                </li>

                                                <li class="slider-wrapper">
                                                    <div class="image">
                                                        <img src="./images/gallery2.jpeg" alt="" />
                                                    </div>
                                                    <div class="slider-caption text-center">
                                                        <div class="container">
                                                        <h1 style={{fontFamily:"Ubuntu"}}>Eticulously Crafted For Superior Engine  Protection And Optimal Airflow.</h1>
                        
                                                        </div>

                                                    </div>
                                                    <div class="slide-overlay"></div>
                                                </li>

                                                <li class="slider-wrapper">
                                                    <div class="image">
                                                        <img src="./images/gallery11.jpeg" alt="" />
                                                    </div>
                                                    <div class="slider-caption text-center">
                                                        <div class="container">
                                                            <h1 style={{fontFamily:"Ubuntu"}}>Explore Our Collection Now And Unleash The Full Potential Of Your Ride</h1>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="slide-overlay"></div>
                                                </li>

                                            </ul>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>         
    </div>
  )
}

export default HomeSlider; 
